import { render, staticRenderFns } from "./PayErrorPopup.vue?vue&type=template&id=2dec0de0&scoped=true"
import script from "./PayErrorPopup.vue?vue&type=script&lang=js"
export * from "./PayErrorPopup.vue?vue&type=script&lang=js"
import style0 from "./PayErrorPopup.vue?vue&type=style&index=0&id=2dec0de0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec0de0",
  null
  
)

export default component.exports